import PropTypes from 'prop-types';
import BEMHelper from 'react-bem-helper';
import _ from 'lodash';

const className = new BEMHelper('information-checkbox');

export default function InformationCheckbox({
    label,
    name,
    isSelected,
    onCheckboxClick,
    additionalInfo,
    disabled = false,
}) {
    const additionalInfoList = _.map(additionalInfo, (infoStr, index) => {
        return <div key={index}>{infoStr}</div>;
    });

    return (
        <div {...className()}>
            <label {...className('label')}>
                <input
                    type="checkbox"
                    name={name}
                    checked={isSelected}
                    onClick={onCheckboxClick}
                    disabled={disabled}
                    readOnly
                />
                <span {...className('input-label')}>{label}</span>
            </label>
            <div {...className('additional-information')}>{additionalInfoList}</div>
        </div>
    );
}

InformationCheckbox.propTypes = {
    label: PropTypes.array.isRequired,
    name: PropTypes.string,
    isSelected: PropTypes.bool,
    disabled: PropTypes.bool,
    onCheckboxClick: PropTypes.func,
    additionalInfo: PropTypes.array,
};
